/**
 * A function that returns class name(s) based on social handle type
 * if network is not found returns default icon  'fa-solid fa-link-horizontal'
 *
 * @example `
 * socialHandleType(('facebook') => 'fa-brands fa-facebook');
 * `
 * @param socialNetwork Social network type
 */

import { SocialNetworksService } from './get-social-networks.service';

export function getSocialIconClass(socialNetworkType: string): string {
  const DEFAULT_ICON = 'fa-solid fa-link-horizontal';
  const socialNetworks = SocialNetworksService.socialNetworks;
  return socialNetworks.find(network => network.id === socialNetworkType)?.icon || DEFAULT_ICON;
}
